export const SUCCESS = 'success';
export const FAIL = 'fail';

export interface Response {
    resultCode: string;
    resultMsg: string;
    data: any;
}

export function isSuccess(resultCode: string) { 
    return resultCode === SUCCESS;
};